/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FufiInvestmentItem
 */
export interface FufiInvestmentItem {
    /**
     * 
     * @type {string}
     * @memberof FufiInvestmentItem
     */
    fundCode: string;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    allocation: number;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    fundValue: number;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    nbUnits?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FufiInvestmentItem
     */
    unitVal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FufiInvestmentItem
     */
    fundName?: string | null;
}

/**
 * Check if a given object implements the FufiInvestmentItem interface.
 */
export function instanceOfFufiInvestmentItem(value: object): value is FufiInvestmentItem {
    if (!('fundCode' in value) || value['fundCode'] === undefined) return false;
    if (!('allocation' in value) || value['allocation'] === undefined) return false;
    if (!('fundValue' in value) || value['fundValue'] === undefined) return false;
    return true;
}

export function FufiInvestmentItemFromJSON(json: any): FufiInvestmentItem {
    return FufiInvestmentItemFromJSONTyped(json, false);
}

export function FufiInvestmentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiInvestmentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'fundCode': json['fundCode'],
        'allocation': json['allocation'],
        'fundValue': json['fundValue'],
        'nbUnits': json['nbUnits'] == null ? undefined : json['nbUnits'],
        'unitVal': json['unitVal'] == null ? undefined : json['unitVal'],
        'fundName': json['fundName'] == null ? undefined : json['fundName'],
    };
}

export function FufiInvestmentItemToJSON(json: any): FufiInvestmentItem {
    return FufiInvestmentItemToJSONTyped(json, false);
}

export function FufiInvestmentItemToJSONTyped(value?: FufiInvestmentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fundCode': value['fundCode'],
        'allocation': value['allocation'],
        'fundValue': value['fundValue'],
        'nbUnits': value['nbUnits'],
        'unitVal': value['unitVal'],
        'fundName': value['fundName'],
    };
}

